var _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClarityLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    viewBox: "0 0 81.1 93.84",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".wpgraphicator-path-ucabeehydldccub3v114w path {animation-name: wpgraphicator-path-ucabeehydldccub3v114w;animation-delay: 0s;animation-duration: 10s;animation-iteration-count: infinite;animation-fill-mode: both;}.wpgraphicator-path-xm8f5n5t3gu111l2o9n1d path {animation-name: wpgraphicator-path-xm8f5n5t3gu111l2o9n1d;animation-delay: 0s;animation-duration: 10s;animation-iteration-count: infinite;animation-fill-mode: both;}.wpgraphicator-path-4mg063v91b2rb15ybrl10 path {animation-name: wpgraphicator-path-4mg063v91b2rb15ybrl10;animation-delay: 0s;animation-duration: 10s;animation-iteration-count: infinite;animation-fill-mode: both;}.wpgraphicator-path-4873gq2y810b9a11lvy8fi path {animation-name: wpgraphicator-path-4873gq2y810b9a11lvy8fi;animation-delay: 0s;animation-duration: 10s;animation-iteration-count: infinite;animation-fill-mode: both;}.wpgraphicator-path-ucabeehydldccub3v114w-angle {animation-name: wpgraphicator-path-ucabeehydldccub3v114w-angle;animation-delay: 0s;animation-duration: 10s;animation-iteration-count: infinite;animation-fill-mode: both;}@keyframes wpgraphicator-path-ucabeehydldccub3v114w-angle {0% {animation-timing-function: linear;transform: rotate(0deg);}100% {animation-timing-function: linear;transform: rotate(900deg);}}@keyframes wpgraphicator-path-ucabeehydldccub3v114w{0% {}100% {}}@keyframes wpgraphicator-path-xm8f5n5t3gu111l2o9n1d{}@keyframes wpgraphicator-path-4mg063v91b2rb15ybrl10{}@keyframes wpgraphicator-path-4873gq2y810b9a11lvy8fi{}")), /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-ucabeehydldccub3v114w-top",
    style: {
      transform: "translateY(46.92px)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-ucabeehydldccub3v114w-left",
    style: {
      transform: "translateX(40.54px)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-ucabeehydldccub3v114w-angle",
    style: {
      transform: "rotate(0deg)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-ucabeehydldccub3v114w-scaleY",
    style: {
      transform: "scaleY(0.76)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-ucabeehydldccub3v114w-scaleX",
    style: {
      transform: "scaleX(0.76)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-ucabeehydldccub3v114w-skewY",
    style: {
      transform: "skewY(0deg)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-ucabeehydldccub3v114w-skewX",
    style: {
      transform: "skewX(0deg)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-ucabeehydldccub3v114w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 24.18 C 12.1 22.18 23.84 3.27 49.87 3.08 C 66.17 2.89 81.33 11.42 89.63 25.45 C 91.42 29.59 90.63 34.92 86.85 36.82 C 82.95 38.97 78.06 37.86 75.48 34.24 C 70.48 27.17 69.9 18.24 56.96 12.98 C 28.93 1.52 9.82 26.24 11 24.17 Z M 89 75.84 C 87.91 77.84 76.18 96.75 50.14 96.92 C 22.83 97.1 10.75 75.49 10.35 74.54 C 8.57 70.41 9.34 65.1 13.13 63.2 C 17.03 61.05 21.92 62.15 24.51 65.77 C 29.51 72.86 30.09 81.77 43.03 87.04 C 71.09 98.48 90.2 73.79 89.03 75.85 Z",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    fill: "#bcbcbc",
    fillOpacity: 1,
    fillRule: "nonzero",
    opacity: 1,
    transform: " translate(-49.99, -50)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-xm8f5n5t3gu111l2o9n1d-top",
    style: {
      transform: "translateY(42.99px)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-xm8f5n5t3gu111l2o9n1d-left",
    style: {
      transform: "translateX(38.54px)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-xm8f5n5t3gu111l2o9n1d-angle",
    style: {
      transform: "rotate(0deg)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-xm8f5n5t3gu111l2o9n1d-scaleY",
    style: {
      transform: "scaleY(0.75)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-xm8f5n5t3gu111l2o9n1d-scaleX",
    style: {
      transform: "scaleX(0.75)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-xm8f5n5t3gu111l2o9n1d-skewY",
    style: {
      transform: "skewY(0deg)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-xm8f5n5t3gu111l2o9n1d-skewX",
    style: {
      transform: "skewX(0deg)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-xm8f5n5t3gu111l2o9n1d"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wpgraphicator-gradient-xg1o30jgnr4ru9cxag99",
    gradientUnits: "objectBoundingBox",
    x1: 0,
    y1: 0.5000000000000001,
    x2: 1,
    y2: 0.4999999999999999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(3,173,111)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(5,144,222)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 52.2 27.79 C 40.82 27.59 30.86 36.09 29.55 46.92 C 28.68 53.27 30.75 59.67 35.18 64.3 C 35.3 64.44 35.44 64.57 35.56 64.71 C 35.68 64.82 35.77 64.96 35.83 65.11 C 35.89 65.26 35.92 65.42 35.92 65.58 C 35.92 65.74 35.88 65.9 35.82 66.05 C 35.75 66.2 35.66 66.33 35.54 66.44 C 35.42 66.55 35.28 66.64 35.13 66.69 C 34.98 66.74 34.81 66.76 34.65 66.75 C 34.49 66.74 34.33 66.7 34.19 66.63 C 34.04 66.55 33.92 66.45 33.81 66.32 C 33.33 65.8 32.81 65.26 32.37 64.7 C 28.53 60.09 26.6 54.17 27 48.18 C 27.28 43.12 29.22 38.29 32.52 34.45 C 36.61 29.41 42.54 26.22 49 25.58 C 55.45 24.78 61.96 26.58 67.09 30.58 C 68.8 31.9 69.47 34.18 68.74 36.22 C 68.38 37.18 67.72 38 66.86 38.56 C 66 39.12 64.99 39.4 63.97 39.35 C 62.99 39.33 62.04 38.97 61.28 38.35 C 58.37 36.03 54.71 34.87 51 35.08 C 50.5 35.08 50 35.16 49.51 35.23 C 49.17 35.31 48.81 35.25 48.52 35.06 C 48.22 34.88 48.02 34.57 47.95 34.23 C 47.91 34.06 47.91 33.89 47.95 33.72 C 48 33.55 48.08 33.4 48.19 33.26 C 48.3 33.13 48.44 33.02 48.6 32.95 C 48.76 32.88 48.93 32.84 49.1 32.84 C 53.85 32.1 58.7 33.37 62.49 36.33 C 62.8 36.58 63.16 36.76 63.55 36.84 C 63.94 36.94 64.34 36.94 64.73 36.84 C 65.66 36.68 66.39 35.94 66.54 35 C 66.76 34.02 66.37 33 65.54 32.43 C 64.26 31.42 62.87 30.57 61.39 29.89 C 58.51 28.54 55.38 27.83 52.2 27.79 Z",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    fill: "url(#wpgraphicator-gradient-xg1o30jgnr4ru9cxag99)",
    fillOpacity: 1,
    fillRule: "nonzero",
    opacity: 1,
    transform: " translate(-47.99, -46.07)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4mg063v91b2rb15ybrl10-top",
    style: {
      transform: "translateY(42.98px)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4mg063v91b2rb15ybrl10-left",
    style: {
      transform: "translateX(38.54px)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4mg063v91b2rb15ybrl10-angle",
    style: {
      transform: "rotate(0deg)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4mg063v91b2rb15ybrl10-scaleY",
    style: {
      transform: "scaleY(0.75)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4mg063v91b2rb15ybrl10-scaleX",
    style: {
      transform: "scaleX(0.75)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4mg063v91b2rb15ybrl10-skewY",
    style: {
      transform: "skewY(0deg)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4mg063v91b2rb15ybrl10-skewX",
    style: {
      transform: "skewX(0deg)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4mg063v91b2rb15ybrl10"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wpgraphicator-gradient-11ukn109wdk7a10hwphr71d",
    gradientUnits: "objectBoundingBox",
    x1: 0,
    y1: 0.5000000000000001,
    x2: 1,
    y2: 0.4999999999999999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(3,173,111)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(5,144,222)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 34.77 67.05 C 34.55 67.05 34.33 67 34.13 66.91 C 33.93 66.83 33.75 66.7 33.61 66.54 C 33.09 66.02 32.61 65.48 32.16 64.9 C 28.26 60.23 26.31 54.23 26.7 48.16 C 26.99 43.04 28.95 38.15 32.28 34.25 C 36.42 29.16 42.41 25.92 48.94 25.25 C 55.47 24.43 62.06 26.25 67.25 30.3 C 69.09 31.68 69.8 34.11 69 36.26 C 68.22 38.33 66.21 39.67 64 39.59 C 62.96 39.59 61.94 39.24 61.12 38.59 C 58.29 36.34 54.73 35.19 51.12 35.37 Q 50.4 35.37 49.68 35.52 C 49.27 35.62 48.83 35.54 48.48 35.31 C 48.12 35.08 47.87 34.72 47.79 34.3 C 47.74 34.11 47.74 33.91 47.79 33.72 C 47.83 33.53 47.92 33.35 48.03 33.19 C 48.32 32.84 48.74 32.61 49.2 32.57 C 54.03 31.84 58.95 33.13 62.81 36.12 C 63.08 36.35 63.4 36.51 63.75 36.58 C 64.08 36.66 64.42 36.66 64.75 36.58 C 65.55 36.43 66.17 35.78 66.29 34.97 C 66.49 34.11 66.16 33.21 65.44 32.69 C 64.18 31.7 62.81 30.86 61.35 30.19 C 58.53 28.88 55.46 28.17 52.35 28.12 L 51.85 28.12 C 40.8 28.12 31.2 36.34 29.85 47 C 29.03 53.27 31.08 59.58 35.43 64.17 L 35.59 64.33 C 35.67 64.41 35.75 64.5 35.82 64.59 C 35.96 64.73 36.07 64.89 36.15 65.07 C 36.23 65.25 36.27 65.45 36.27 65.65 C 36.27 65.85 36.23 66.04 36.15 66.22 C 36.07 66.4 35.96 66.57 35.82 66.71 C 35.53 66.96 35.15 67.08 34.77 67.05 Z M 52 25.67 C 51 25.67 50 25.73 49 25.85 C 42.62 26.5 36.77 29.66 32.73 34.64 C 29.48 38.44 27.56 43.2 27.28 48.2 C 26.89 54.12 28.79 59.96 32.58 64.52 C 32.97 65 33.43 65.52 34.02 66.12 C 34.1 66.23 34.2 66.32 34.31 66.39 C 34.42 66.46 34.54 66.5 34.67 66.51 C 34.93 66.54 35.2 66.45 35.39 66.27 C 35.49 66.18 35.56 66.07 35.61 65.95 C 35.66 65.83 35.69 65.7 35.68 65.57 C 35.67 65.44 35.64 65.32 35.58 65.2 C 35.52 65.08 35.43 64.98 35.33 64.9 L 35.11 64.67 L 35 64.49 C 30.53 59.79 28.43 53.32 29.28 46.89 C 30.59 36 40.45 27.5 51.78 27.5 L 52.2 27.5 C 55.43 27.53 58.62 28.26 61.55 29.63 C 63.05 30.32 64.46 31.18 65.76 32.19 C 66.21 32.51 66.56 32.95 66.76 33.46 C 66.93 33.96 66.95 34.49 66.83 35 C 66.75 35.5 66.51 35.97 66.16 36.33 C 65.81 36.7 65.36 36.95 64.86 37.06 C 64.43 37.17 63.98 37.17 63.55 37.06 C 63.12 36.97 62.71 36.78 62.37 36.5 C 58.63 33.61 53.86 32.39 49.2 33.15 C 49.05 33.16 48.9 33.2 48.77 33.27 C 48.64 33.34 48.52 33.43 48.42 33.54 C 48.35 33.64 48.3 33.75 48.27 33.86 C 48.25 33.98 48.25 34.1 48.27 34.22 C 48.35 34.74 48.86 35.04 49.52 34.95 C 50.02 34.87 50.52 34.82 51.03 34.79 C 54.79 34.59 58.49 35.77 61.44 38.11 C 62.17 38.68 63.07 38.99 64 39 C 65.99 39.09 67.81 37.87 68.48 36 C 68.83 35.07 68.87 34.05 68.59 33.09 C 68.31 32.14 67.73 31.3 66.94 30.7 C 62.66 27.41 57.4 25.64 52 25.67 Z",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    fill: "url(#wpgraphicator-gradient-11ukn109wdk7a10hwphr71d)",
    fillOpacity: 1,
    fillRule: "nonzero",
    opacity: 1,
    transform: " translate(-47.99, -46.06)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4873gq2y810b9a11lvy8fi-top",
    style: {
      transform: "translateY(49.08px)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4873gq2y810b9a11lvy8fi-left",
    style: {
      transform: "translateX(41.47px)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4873gq2y810b9a11lvy8fi-angle",
    style: {
      transform: "rotate(0deg)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4873gq2y810b9a11lvy8fi-scaleY",
    style: {
      transform: "scaleY(0.75)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4873gq2y810b9a11lvy8fi-scaleX",
    style: {
      transform: "scaleX(0.75)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4873gq2y810b9a11lvy8fi-skewY",
    style: {
      transform: "skewY(0deg)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4873gq2y810b9a11lvy8fi-skewX",
    style: {
      transform: "skewX(0deg)"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "wpgraphicator-path-4873gq2y810b9a11lvy8fi"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wpgraphicator-gradient-hl10qoytg62pe117o811ux6",
    gradientUnits: "objectBoundingBox",
    x1: 0,
    y1: 0.5000000000000001,
    x2: 1,
    y2: 0.4999999999999999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(3,173,111)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(5,144,222)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 52.47 73.88 C 48.14 73.98 43.85 72.99 40 71 C 39.68 70.88 39.43 70.63 39.3 70.31 C 39.18 69.99 39.19 69.64 39.34 69.33 C 39.42 69.18 39.53 69.05 39.66 68.94 C 39.79 68.84 39.94 68.76 40.1 68.72 C 40.27 68.69 40.44 68.69 40.61 68.72 C 40.78 68.75 40.93 68.81 41.07 68.91 C 43.47 70.2 46.08 71.03 48.78 71.36 C 54.15 72.05 59.59 70.83 64.14 67.9 C 64.62 67.59 65.14 67.26 65.54 66.9 C 65.81 66.7 66.05 66.45 66.23 66.17 C 66.41 65.89 66.53 65.57 66.58 65.24 C 66.65 64.91 66.65 64.57 66.58 64.24 C 66.51 63.91 66.37 63.6 66.17 63.33 C 65.73 62.83 65.12 62.51 64.45 62.44 C 63.78 62.37 63.11 62.55 62.58 62.96 C 60.25 64.78 57.5 65.96 54.58 66.39 C 45.74 67.78 36.18 62.47 34.45 52.27 C 33.32 44.99 37.06 37.83 43.68 34.6 C 43.82 34.51 43.98 34.46 44.14 34.44 C 44.3 34.41 44.47 34.41 44.63 34.44 C 44.79 34.49 44.93 34.57 45.06 34.67 C 45.19 34.77 45.3 34.9 45.37 35.05 C 45.45 35.2 45.49 35.36 45.5 35.52 C 45.51 35.68 45.48 35.85 45.43 36 C 45.37 36.16 45.28 36.3 45.16 36.42 C 45.05 36.54 44.91 36.63 44.76 36.69 C 42.71 37.71 40.92 39.18 39.53 41 C 36.86 44.51 35.96 49.06 37.09 53.32 C 38.22 57.59 41.25 61.09 45.31 62.82 C 50.44 65.27 56.52 64.6 61 61.1 C 62.93 59.62 65.64 59.69 67.49 61.27 C 67.99 61.76 68.39 62.35 68.64 63 C 68.89 63.64 69.01 64.32 68.99 65 C 68.93 66.42 68.25 67.75 67.14 68.64 C 64.28 70.85 60.97 72.41 57.44 73.19 C 55.81 73.59 54.15 73.83 52.47 73.88 Z",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    fill: "url(#wpgraphicator-gradient-hl10qoytg62pe117o811ux6)",
    fillOpacity: 1,
    fillRule: "nonzero",
    opacity: 1,
    transform: " translate(-51.62, -54.15)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityLoader);
export default __webpack_public_path__ + "static/media/clarity_loader.660e470b4313a2af1ebf8312a2b02255.svg";
export { ForwardRef as ReactComponent };